import { useState } from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"
import Typography from "../styled/Typography"
import Icon from "../icons/icon"
import { Plus } from "../icons/plus"
import { Minus } from "../icons/minus"

const Wrapper = styled.div`
  padding: 15px 0;
  border-bottom: solid 1px ${({ theme }) => theme.colors.paleGray};
`

const Title = styled(Typography)`
  margin: 0;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Dropdown = styled.div`
  max-height: 0;
  transition: max-height 0.25s ease-out;
  overflow: hidden;
  &.active {
    max-height: 500px;
    transition: max-height 0.35s ease-in;
  }
`

const Text = styled(Typography)`
  font-weight: 400;
  margin-top: 1.5rem;
`

export default function Question({ item }) {
  const { question, answer } = item

  const [isOpen, setIsOpen] = useState(false)

  return (
    <Wrapper>
      <Header onClick={() => setIsOpen(s => !s)}>
        <Title color="skyBlue" weight="medium" space>
          {question}
        </Title>
        <Icon color="deepPink" size="xs" Icon={isOpen ? Minus : Plus} />
      </Header>
      <Dropdown className={isOpen ? "active" : null}>
        <Text variant="small" dangerouslySetInnerHTML={{ __html: answer }} />
      </Dropdown>
    </Wrapper>
  )
}

Question.propTypes = {
  item: PropTypes.object.isRequired
}
